import React from "react";
import { observer } from "mobx-react";

import MultiSelectWithDoDOrdering from "../../../general/MultiSelectWithDoDOrdering";
import { TooltipWithText } from "../../tooltip/TooltipWithText";

import "./CubeLinks.scss";

const CubeLinksComponent = ({ store }) =>
  Object.keys(store.cubeLinks).length > 0 && (
    <section className="CubeLinks">
      <h4 className="CubeLinks_header">
        Link with data of Cubes from other Data Models or Frameworks
        <TooltipWithText id="cube_links_info">
          <span className="sr-only">Info:</span>
          This section allows you to join different tables (Cubes) belonging to
          different Data Models/Frameworks. For example it is possible to
          breakdown aggregated data to comparable granular data (e.g. AnaCredit
          with FINREP). Once selected, the respective fields (Variables) will
          also be available in the current Query. The join criteria is "LEFT
          JOIN": i.e. only the matching records between the joint Cubes will be
          returned; change to "LEFT" in case all the records of the current Cube
          (in accordance with the selection criteria) should be returned. Please
          be aware that the quality of the matched results depend also on the
          quality and nature of the joint data. See in Matching cubes from other
          Frameworks section of the Cube view for more information.
        </TooltipWithText>
      </h4>
      <div>
        <MultiSelectWithDoDOrdering
          disabled={store.filterByVariableDisabled}
          options={store.cubeLinksOptions}
          order={store.selectedCubeLinks}
          values={store.selectedCubeLinks}
          placeholder="Select link to Cube"
          allowSelectMultipleTimes={false}
          onChangeOrder={store.addSelectedCubeLinksItem}
          onAdd={store.addSelectedCubeLinksItem}
          onDelete={store.deleteAllSelectedCubeLinksItems}
        >
          {store.selectedCubeLinks.map((cubeId) => (
            <div key={cubeId} className="CubeQueryWizard__row item">
              {store.foreignCubes[cubeId].loading ? (
                <div className="x-icon">
                  <div className="query-wizard-loader"></div>
                </div>
              ) : (
                <div
                  className="x-icon"
                  aria-hidden="true"
                  onClick={() => store.deleteSelectedCubeLinksItem(cubeId)}
                >
                  ×
                </div>
              )}
              <div className="item-texts">
                {`${store.foreignCubes[cubeId].details.name} (${
                  store.foreignCubes[cubeId].details.code
                }) ${
                  store.foreignCubes[cubeId].loading
                    ? "(Wait while loading cube structure)"
                    : ""
                }`}
              </div>
            </div>
          ))}
        </MultiSelectWithDoDOrdering>
      </div>
      <hr />
    </section>
  );

export const CubeLinks = observer(CubeLinksComponent);
